import React, { useState } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useSignIn, useAuthUser } from 'react-auth-kit';

// GRAPHQL QUERY
import { 
    SaveUser
} from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook
import { useMutation } from '@apollo/client';



export function MyAccountComponent(props) {
    const auth = useAuthUser();
    const signIn = useSignIn();

    const [SelectedUser, setSelectedUser] = useState({ ...auth().User, old_password: '', new_password: '', new_password2: '' });

    const [BaseState, setBaseState] = useState({
        action: '',
        old_password_message: '',
        old_password_message_class: '',
        save_button_text: 'Save', 
        save_message: ''
    });

    const [save_user] = useMutation(SaveUser);

    // Update the state for any changing input
    function changeInputValue(name, value) {

        setSelectedUser({
            ...SelectedUser, 
            [name]: value 
        });
    }

    // Save Player Details
    async function handleSave() {

        let SaveData = { first_name: SelectedUser.first_name, last_name: SelectedUser.last_name, email: SelectedUser.email, phone_number: SelectedUser.phone_number, user_ID: parseInt(SelectedUser.user_ID) };

        // Only send password if there was a new password saved
        if ( SelectedUser.new_password !== '' ) {
            SaveData = { ...SaveData, password: SelectedUser.new_password };
        }

        const result = await save_user({ variables: { input: { ...SaveData } }});

        // Update the Users - save returns an array of all User objects
        if(result.data && result.data.userSave.User) {

            signIn({
                token: 345234523452345,
                expiresIn: 3600*16,
                tokenType: "Bearer",
                authState: { User: {...auth().User, password: SelectedUser.new_password } }
            });

            setSelectedUser({
                ...SelectedUser,
                old_password: '',
                password: SelectedUser.new_password, 
                new_password: '', 
                new_password2: '' 
            });
            
            setBaseState({
                ...BaseState,
                action: 'saved',
                old_password_message: '',
                old_password_message_class: ''
            });


        }
    }

    // Compare user's entered old password before allowing to proceed
    function handleCompareOldPassword() {
    
        if ( SelectedUser.old_password !== SelectedUser.password ) {
            setBaseState({ ...BaseState, old_password_message: 'Does not match current password', old_password_message_class: 'text-danger' });
        } else {
            setBaseState({ ...BaseState, old_password_message: 'Matches current password', old_password_message_class: 'text-success' });
        }
    
    }

    function handleCancelChangePassword() {

        setBaseState({ 
            ...BaseState, 
            action: '', 
            old_password_message: '', 
            old_password_message_class: ''
        });

        setSelectedUser({
            ...SelectedUser,
            old_password: '', 
            new_password: '', 
            new_password2: '' 
        });
    }

    function handleCompareNewPasswords() {
    
    }

    return (
        <div className="row justify-content-center mt-4">
            <div className="col-lg-6 col-md-12 col-sm-12 text-secondary border bg-light rounded p-5">
                <div className="row mx-0">
                    <div className="form-floating mb-2 col-6 p-0 pe-1">
                        <input className="form-control float" id="first_name" value={SelectedUser.first_name} onChange={(event) => changeInputValue('first_name', event.target.value)} /> 
                        <label className="text-muted" htmlFor="first_name">First Name *</label>
                    </div>
                    <div className="form-floating mb-2 col-6 p-0 ps-1">
                        <input className="form-control float" id="last_name" value={SelectedUser.last_name} onChange={(event) => changeInputValue('last_name', event.target.value)} /> 
                        <label className="text-muted" htmlFor="last_name">Last Name *</label>
                    </div>
                </div>
                <div className="row mx-0">
                    <div className="form-floating mb-2 col-6 p-0 pe-1">
                        <input className="form-control float" id="phone_number" value={SelectedUser.phone_number} onChange={(event) => changeInputValue('phone_number', event.target.value)} /> 
                        <label className="text-muted" htmlFor="phone_number">Phone Number</label>
                    </div>
                    <div className="form-floating mb-2 col-6 p-0 ps-1">
                        <input className="form-control float" id="email" value={SelectedUser.email} onChange={(event) => changeInputValue('email', event.target.value)} /> 
                        <label className="text-muted" htmlFor="email">Email *</label>
                    </div>
                </div>
                <div className="row mx-0">
                    {
                        BaseState.action === 'change_password' &&
                        <>
                            <div className="alert alert-info alert-sm mb-2 col-12 text-center p-2">Enter your current password before changing it</div>
                            <div className="form-floating mb-2 col-6 p-0 pe-1">
                                <input className="form-control float" id="old_password" value={SelectedUser.old_password} onChange={(event) => changeInputValue('old_password', event.target.value)} onBlur={() => handleCompareOldPassword()} disabled={SelectedUser.new_password !== '' || SelectedUser.new_password2 !== ''} /> 
                                <label className="text-muted" htmlFor="old_password">Current Password</label>
                            </div>
                            <div className="mb-2 col-6">
                                <div className="mt-4 pt-2">
                                    {
                                        BaseState.old_password_message !== '' &&
                                        <span className={`${BaseState.old_password_message_class}`} style={{ fontSize: 14+'px'}}>
                                            <FontAwesomeIcon icon={`${( BaseState.old_password_message_class === 'text-danger' && 'fa-times' ) || 'fa-check'}`} className="me-2" />{BaseState.old_password_message}
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="form-floating mb-2 col-6 p-0 pe-1">
                                <input className="form-control float" id="new_password" value={SelectedUser.new_password} onChange={(event) => changeInputValue('new_password', event.target.value)} disabled={SelectedUser.password !== SelectedUser.old_password} /> 
                                <label className="text-muted" htmlFor="new_password">New Password: </label>
                            </div>
                            <div className="form-floating mb-2 col-6 p-0 ps-1">
                                <input className="form-control float" id="new_password2" value={SelectedUser.new_password2} onChange={(event) => changeInputValue('new_password2', event.target.value)} disabled={SelectedUser.password !== SelectedUser.old_password} /> 
                                <label className="text-muted" htmlFor="new_password2">Confirm New Password: </label>
                            </div>
                        </>
                    }
                    
                </div>

                <div className="clearfix mt-2">
                    <span className="float-start">
                        <button className="btn btn-sm fw-bold col-auto border-success border-3 text-success" onClick={() => handleSave()} disabled={SelectedUser.new_password !== SelectedUser.new_password2}>
                            <FontAwesomeIcon icon={`${(SelectedUser.save_button_text === 'Saved' && 'fa-check') || 'fa-floppy-disk'}`} className="me-2" />Save
                        </button>
                            {
                                SelectedUser.new_password !== SelectedUser.new_password2 &&
                                    <span className="text-danger ms-2" style={{ fontSize: 14+'px'}}>
                                        <FontAwesomeIcon icon="fa-times" className="me-2" />New passwords do not match
                                    </span>
                            }
                            {
                                SelectedUser.new_password === SelectedUser.new_password2 && SelectedUser.new_password2 !== '' &&
                                    <span className="text-success ms-2" style={{ fontSize: 14+'px'}}>
                                        <FontAwesomeIcon icon="fa-check" className="me-2" />New passwords match
                                    </span>
                            }
                    </span>
                    {
                        BaseState.action !== 'change_password' &&
                        <span className="float-end">
                            <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" onClick={() => setBaseState({ ...BaseState, action: 'change_password' })} disabled={false}>
                                <FontAwesomeIcon icon="fa-key" className="me-2" />Change Password
                            </button>
                        </span>
                    }
                    {
                        BaseState.action === 'change_password' &&
                        <span className="float-end">
                            <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" onClick={() => handleCancelChangePassword()}>
                                <FontAwesomeIcon icon="fa-times" className="me-2" />Cancel Change Password
                            </button>
                        </span>
                    }
                </div>

                {
                    BaseState.action === 'saved' &&
                    <div className="alert alert-success mt-3">Account information successfully updated</div>
                }
            </div>
        </div>
    )
}

